import { IN_PERSON_TRAINING } from 'constants/actionTypes';

const initialState = {
  updateEmail: {
    confirmationVisible: false,
    resource: null,
    changedAttributes: [],
  },
  /**
   * When a user removes themselves as a session trainer
   */
  trainerChange: {
    confirmationVisible: false,
    // A temporary reference to the changes of the session being edited.
    session: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case IN_PERSON_TRAINING.EVENT_CHANGE_MANAGEMENT
      .TOGGLE_CONFIRM_TRAINER_CHANGE:
      return {
        ...state,
        trainerChange: {
          confirmationVisible: !state.trainerChange.confirmationVisible,
          session: !state.trainerChange.confirmationVisible
            ? action.session
            : initialState.session,
        },
      };
    case IN_PERSON_TRAINING.EVENT_CHANGE_MANAGEMENT.TOGGLE_UPDATE_EMAIL:
      return {
        ...state,
        updateEmail: {
          confirmationVisible: !state.updateEmail.confirmationVisible,
          resource: action.resource,
          changedAttributes: action.changedAttributes,
        },
      };

    default:
      return state;
  }
};
